(function () {

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".pickup-trigger");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    const modalContent = document.getElementById("PickupModalContent");

    modalContent.innerHTML = "Loading...";

    try {
      // Fetch product page section (lightweight)
      const res = await fetch(`/products/${handle}?section_id=pickup-availability`);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, "text/html");

      const pickup = doc.querySelector("#pickup-availability");

      if (pickup) {
        modalContent.innerHTML = pickup.innerHTML;
      } else {
        modalContent.innerHTML = "Pickup not available";
      }

    } catch (err) {
      console.error(err);
      modalContent.innerHTML = "Error loading pickup info";
    }
  });
  
})();